export const INITIAL_RISK_ASSESSMENT_HEADERS = {
  riskAssessmentCategory: "Category",
  riskAssessmentStudySpecifics: "Study Specifics",
  riskAssessmentRiskScore: "Risk Score",
  riskAssessmentLow: "Low",
  riskAssessmentModerate: "Moderate",
  riskAssessmentHigh: "High",
};

export const INITIAL_RISK_WIDTHS = {
  category: "10%",
  studySpecifics: "22%",
  riskScore: "8%",
  low: "20%",
  moderate: "20%",
  high: "20%",
  lowMediumHigh: "60%",
};
